<!-- 特殊业务标识/业务事项 -->
<template> 
    <div>
        <el-dialog v-dialogDrag :title="specialBusinessType === 0 ?'特殊业务标识':'业务事项'" :visible.sync="specialBusinessShow" width="60%" :before-close="handleClose" 
        :close-on-click-modal="false">
        <!-- 特殊业务标识 -->
            <el-checkbox-group v-model="checkBusinessList" v-if="specialBusinessType === 0">
                <el-checkbox v-for="item in specialBusinessList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue" ></el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group v-model="checkMattersList" v-else>
                <el-checkbox v-for="item in businessMattersList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue" ></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'

export default {
    props: {
        specialBusinessShow: {
            type: Boolean,
            default: false
        },
        specialBusinessType:{
            // 0：特殊业务标识  1：业务事项
            type: Number,
            default: 0
        },
        // 回显的值
        specialBusinessValue:{
            type:String,
            default:''
        },
    },
    data() {
        return {
            checkBusinessList:[], // 特殊业务标识选中列表
            specialBusinessList:AEObasicData.specialBusinessList,
            checkMattersList:[],
            businessMattersList:AEObasicData.businessMattersList,
        }
    },
    watch: {
        specialBusinessShow:{
            handler(val) {
                if(val){
                    // 判断是否是特殊业务标识
                    if(this.specialBusinessType == 0){
                        if(this.specialBusinessValue){
                            this.checkBusinessList = this.specialBusinessValue.split(',')
                        }else{
                            this.checkBusinessList = []
                        }
                    }
                }else{
                    this.checkBusinessList = []
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() { 
    },
    methods: { 
        sure() {
            // 挨个判断有则1无则0
            if(this.specialBusinessType === 0){
                var value = ''
                var text = ''
                value = value.concat( this.checkBusinessList.indexOf('国际赛事') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('特殊进出军工物资') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('国际援助物资') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('国际会议') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('直通放行') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('外交礼遇') === -1 ? '0' : '1' )
                value = value.concat( this.checkBusinessList.indexOf('转关') === -1 ? '0' : '1' )
                text = this.checkBusinessList.join(',')
                this.$emit('specialBusinessClose',this.specialBusinessType, value,text);
            }else{
                this.$emit('specialBusinessClose',this.specialBusinessType, '','');
            }
            
        },
        handleClose(){
            this.$emit('specialBusinessClose', false);
        },
    }
}
</script>
<style lang="css" scoped>

</style>